if (typeof SwatchItem !== 'function') {

    isCollection = document.body.classList.contains('template-collection');
    class SwatchItem extends HTMLElement {
        constructor() {
            super();
            this.cache = new Map();
            this.init();
        }

        async isVariant () {
            return await window.shoplift.isHypothesisActive('019b8f46-8fd3-7e2b-9ad1-696cb7109d01');
        }

        init() {
            this.fetch = this.getAttribute('fetch');
            this.fetch = new URL(this.fetch, `${window.location.origin}${Shopify.routes.root}`);

            this.value = this.getAttribute('value');

            this.targetContainer = this.closest('.product-item')?.querySelector('[data-js-product-item-image]');
            
            if (!this.fetch || !this.targetContainer) return;
            
            const prefetchEvent = 'ontouchstart' in window ? 'touchstart' : 'mouseenter';
            this.addEventListener(prefetchEvent, () => this.prefetch(), { once: true, passive: true });


            if (this.hasAttribute('checked')) {
                // this.matchB4B();
                this.updateColorLabel();
                this.updateProductCard();
            }
            
            this.addEventListener('click', (e) => {
                e.preventDefault();
                this.updateSwatches();
                this.updateLinks();
                this.fetchProduct();
                this.updateColorLabel();
                this.updateProductCard();
            });
        }

        updateLinks() {
            const links = this.closest(`.product-item`).querySelectorAll('a');
            const modal = this.closest(`.product-item`).querySelector('product-modal-toggle');
            
            const url = new URL(this.fetch);
            url.searchParams.delete('sections');

            modal.setAttribute('data-product-url', url.toString());
            links.forEach(link => {
                link.setAttribute('href', url);
            });
        }

        updateColorLabel() {
            const colorLabel = this.closest('.product-item').querySelector('[data-js-color-label]');
            if (colorLabel) {
                colorLabel.textContent = this.value;
            }
        }

        updateProductCard() {
            const productCard = this.closest('.product-item');
            if (productCard) {
                productCard.setAttribute('color', this.value);
            }
        }

        updateSwatches() {
            if (this === this.closest('swatch-item[checked]')) return;
            const swatchItems = this.closest('.product-item-swatches').querySelectorAll('swatch-item');
            swatchItems.forEach(item => {
                item.removeAttribute('checked');
            });

            this.setAttribute('checked', '');
        }

        async prefetch() {
            if (this.cache.has(this.fetch)) return;
            
            try {
                const response = await fetch(this.fetch);
                const text = await response.text();
                const content = this.parseHTML(text);
                this.cache.set(this.fetch, content);
            } catch (e) {
                // Silent fail
            }
        }

        async fetchProduct() {
            if (this.cache.has(this.fetch)) {
                this.updateImages(this.cache.get(this.fetch));
                this.updatePrice(this.cache.get(this.fetch));
                this.updateBadges(this.cache.get(this.fetch));
                return;
            }

            try {
                const response = await fetch(this.fetch);
                const text = await response.text();
                const content = this.parseHTML(text);
                
                this.cache.set(this.fetch, content);

                this.updateImages(content);
                this.updatePrice(content);
                this.updateBadges(content);
            } catch (error) {
                console.error('Swatch fetch failed:', error);
            }
        }

        async updateImages(content) {
            const image = this.closest('.product-item')?.querySelector('[data-js-product-item-image]');

            if(isCollection) {
                const newImage = await this.isVariant() ? content.querySelector('[data-js-a-b-image]') : content.querySelector('[data-js-product-item-image-primary]');
                const hoverImage = content.querySelector('product-item-hover');

                image.innerHTML = newImage.innerHTML;
                image.appendChild(hoverImage.cloneNode(true));
            } else {
                const newImage = content.querySelector('[data-js-product-item-image]');
                image.innerHTML = newImage.innerHTML;
            }
        }

        updateBadges(content) {
            const productItem = this.closest('.product-item');
            if (!productItem) return;

            const currentBadges = productItem.querySelector('.product-item__badges');
            const newBadges = content.querySelector('.product-item__badges');

            if (!currentBadges) return;
            
            if (!newBadges) {
                currentBadges.innerHTML = '';
                return;
            }
    
            currentBadges.innerHTML = newBadges.innerHTML;
        }

        updatePrice(content) {
            const price = this.closest('.product-item')?.querySelector('[data-js-product-item-price]');
            const newPrice = content.querySelector('[data-js-product-item-price]');
            price.innerHTML = newPrice.innerHTML;
        }

        parseHTML(text) {

            const json = JSON.parse(text);
            text = json['helper-variant-image'] || json['helper-variant-image-collection'];

            const doc = new DOMParser().parseFromString(text, 'text/html');
            const section = doc.querySelector('.shopify-section');
            return section;
        }
    }

    customElements.define('swatch-item', SwatchItem);
}


if (typeof SwatchContainer !== 'function') {
    class SwatchContainer extends HTMLElement {
        constructor() {
            super();
            this.swatches = this.querySelectorAll('swatch-item');
            this.limitSwatches();
            window.addEventListener('resize', () => debounce(this.limitSwatches(), 300));
        }

        limitSwatches() {
            const isMobile = window.innerWidth <= 768;
            this.maxSwatches = this.dataset.limit ? this.dataset.limit : isMobile ? 5 : 8;

            this.swatches.forEach((swatch, index) => {
                if (index >= this.maxSwatches) {
                    swatch.style.display = 'none';
                } else {
                    swatch.style.display = 'block';
                }
            })  
            if (this.swatches.length > this.maxSwatches) {
                const existing = this.querySelector('.swatch-more');
                if (!existing) {
                    const remaining = this.swatches.length - this.maxSwatches;
                    const moreText = document.createElement('span');
                    moreText.className = 'swatch-more';
                    moreText.textContent = `+ ${remaining}`;
                    this.appendChild(moreText);
                } else {
                    const remaining = this.swatches.length - this.maxSwatches;
                    existing.textContent = `+ ${remaining}`;
                }
            }
        }
    }

    customElements.define('swatch-container', SwatchContainer);
}